var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalleyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 217.6",
    style: {
      enableBackground: "new 0 0 684 217.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.2,123.9l-65-32.4c-2.8-1.4-6.2-1.4-9,0l-65,32.4v-64H30.3h-30c-0.2,0-0.3,0.3-0.1,0.4l30.2,17.6v64 c0,6.1,7.5,9.9,13.5,6.9l76.9-38.4l76.9,38.4c6,3,13.5-0.8,13.5-6.9v-82h-20.9V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.4,59.8c-20.6,0-38.3,3.3-56.5,8.6l6.4,16.5c19.7-6.1,34.6-7.6,47.3-7.6c13.1,0,36.2,2.5,36.8,21.7 c-13.8-3.8-29.5-6.5-45.5-6.5c-27.6,0-52.2,7.4-52.2,30.4c0,20.3,14.7,29.4,41.1,29.4c21.2,0,39.7-5.7,56.6-13.5v11h21.8v-44.5 C342.9,71.2,324.2,59.8,287.4,59.8z M321.4,123.9c-14.7,5.2-36.4,10.7-49.8,10.6c-15.3,0-24.6-2.1-24.6-12.3 c0-9.5,11.7-13.2,30.9-13.2c17.5,0,31.6,2.8,43.6,6.1V123.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.4,
    y: 32.1,
    width: 21.6,
    height: 117.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 32.1,
    width: 21.6,
    height: 117.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.6,119.9L521.6,119.9c-4.1,8.4-13.4,14.1-34.4,14.1c-23.1,0-36.6-6.6-38.7-23.4h97c0-37.6-25.9-50.7-60.1-50.7 c-33.8,0-59.8,14.8-59.8,46s25,46,61.2,46c32.2,0,52.2-11.9,57.5-32.1H521.6z M485.4,76.9c20,0,32.3,5.6,36.1,18.5h-71.9 C453.8,82.3,466.6,76.9,485.4,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.7,60l-42.9,78l-42.7-78h-24.9l49.2,89.7h12l-0.6,1.2c-8.3,15.6-15.1,19.4-28.1,19.4c-6.6,0-15.1-0.8-26.6-3.4v19 c9.7,2,19.1,3.5,30.6,3.5c23.2,0,34.6-12.4,46.1-33.8L673.2,60H648.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalleyLogo);
export default __webpack_public_path__ + "static/media/walley-logo.ac9cb7eda10079e2525664a8b9b07bde.svg";
export { ForwardRef as ReactComponent };